import React from "react";
import Select from "react-select";
import { ControlledInput } from "../../../common/Input/Input";
import { Button } from "../../../common/Button/Button";

export default function CustomerFilter(props) {
	return (
		<>
			{ 
			props.hidecustomerfilter?(<div></div>)
			:(
				<Select
					placeholder="Select Customer Filter"
					options={props.options}
					onChange={props.onCustomerFilterChange}
					value={props.customerFilter}
				></Select>
			)}
			<ControlledInput
					placeholder={props.hidecustomerfilter?("Search..."):("Search name or email...")}
					// onChange={(event) => { event.persist();debounce(() => {props.onSearchInputChange(event)},1000)}}
					onChange={props.onCustomerFilterValueChange}
					onKeyPress={(e) => {
						if (e.key === "Enter") {
							props.onSearchClicked();
						}
					}}
					value={props.customerFilterValue}
			/>
		</>
	);
}
